// extracted by mini-css-extract-plugin
module.exports = {"root":"PaginationBottom-root-3cc5","more":"PaginationBottom-more-3cc5"};